import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PopoverController} from '@ionic/angular';
import { Profile } from '../../models/profile.model';
import { ArticlesService } from '../../services/articles.service';
import { StorageProvider } from '../../services/storage.provider';

import { InfoPopupComponent } from '../../shared/components/infopopup/infopopup';
import { MetaProvider } from '../../services/meta.provider';

import { ConfigService } from '../../services/config.service';
import { AuthProvider } from '../../services/auth.provider';

@Component({
  selector: 'app-loginprofile',
  templateUrl: 'loginprofile.html',
  styleUrls: ['loginprofile.scss']
})
export class LoginProfilePage implements OnInit {
  public profile: any;
  public model = new Profile('', '', '', '', '', '');
  public error: string;
  public noResetPswd: boolean;
  private accessToken: string;

  constructor(
    private actRoute: ActivatedRoute,
    private router: Router,
    public service: ArticlesService,
    public popoverCtrl: PopoverController,
    private storage: StorageProvider,
    private meta: MetaProvider,
    private config: ConfigService,
    private auth: AuthProvider
  ) { }

  ngOnInit(): void {
    this.accessToken = this.storage.getStorage('access_token');
    this.actRoute.queryParamMap.subscribe(
      params => {
        this.profile = params.get('profile') ? JSON.parse(params.get('profile')) : null;
      }
    );
  }

  ionViewDidEnter() {
    this.meta.clearHead();
    if (this.storage.getStorage('cas')) {
      this.noResetPswd = true;
    } else {
      this.noResetPswd = false;
    }
  }

  loginProfile() {
    this.service.authenticateProfile(this.model, this.accessToken).subscribe(
      (response) => {
        if (response.message === 'Parent password accepted.') {
          this.storage.setStorage('logged_profile_id', this.profile.profile_id);
          this.storage.setStorage( 'logged_profile_name', this.profile.profile_firstName);
          this.storage.setStorage( 'logged_profile_type', this.profile.profile_type);
          if (this.profile.profile_nickName) {
            this.storage.setStorage( 'logged_profile_nickname', this.profile.profile_nickName);
          } else {
            this.storage.removeStorage('logged_profile_nickname');
          }
          if (this.profile.profile_avatar_path) {
            this.storage.setStorage( 'logged_profile_avatar', this.profile.profile_avatar_path);
          } else {
            this.storage.removeStorage('logged_profile_avatar');
          }
          this.error = '';
          this.goToMyNews();
        }
      },
      () => this.error = 'Le mot de passe saisi est incorrect'
    );
  }

  goToMyNews() {
    const newspaperAccess = Object.keys(this.profile.access);
    if (this.storage.getStorage('coupon')) {
      this.router.navigate(['ajouter-code-gratuit']);
    } else {
      if (this.storage.getStorage('access') || this.storage.getStorage('printAccess')) {
        this.router.navigate(['']);
      } else {
        this.router.navigate(['pdf','choisir-un-titre']);
      }
      // if (
      //   this.auth.checkAccessOnlyWeekly(newspaperAccess) &&
      //   this.storage.getStorage('printaccess')
      // ) {
      //   this.router.navigate(['pdf', 'choisir-un-titre']);
      // } else if (this.auth.checkAccessOnlyWeeklyandVideo(newspaperAccess)) {
      //   this.router.navigate(['']);
      // } else {
      //   if (
      //     this.storage.getStorage('access') &&
      //     this.auth.containsNonWeeklyorVideoWithWeb(this.profile.access)
      //   ) {
      //     this.router.navigate(['exposes', '']);
      //   } else {
      //     this.router.navigate(['pdf', 'choisir-un-titre']);
      //   }

      //   if (
      //     !this.storage.getStorage('access') &&
      //     this.storage.getStorage('printaccess')
      //   ) {
      //     this.router.navigate(['pdf', 'choisir-un-titre']);
      //   }
      // }
    }
  }

  goToForgotPassword() {
    this.router.navigate(['connexion', 'oubli-mot-de-passe']);
  }

  async presentPopover(myEvent) {
    const popover = this.popoverCtrl.create({
      component: InfoPopupComponent,
      componentProps: { page: 'step2' },
      cssClass: 'password-tooltip'
    });
    (await popover).present(myEvent);
  }

  isLogin() {
    return 'login';
  }

  getDefaultAvatar(profile): string {
    const avatar = this.config.getDefaultAvatar();
    return avatar[profile.profile_type];
  }
}
